import React from 'react';
import CSSModules from 'react-css-modules';
import style from './card.scss';
import omit from 'lodash/omit';
import { H2 } from '.';

const Card = ({ children, ...rest }) => (
  <div {...omit(rest, 'styles', 'header')} styleName={`root`}>
    <div styleName="inner">
      {
        rest.header ?
          <div styleName="header">
            {
              typeof rest.header === "string" ?
                <H2>{rest.header}</H2>
              : (rest.header)
            }
          </div>
        : null
      }
      {children}
    </div>
  </div>
);

export default CSSModules(Card, style, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/card.js